import React, { useState } from "react";
import fallbackImage from "assets/images/disable_image.jpg";
import { ReactComponent as ImageGalleryIcon } from "assets/icons/gallery_icon.svg";
import useProperties from "hooks/useProperties";
import CardImageViewerSlider from "components/Card/SearchCard/components/CardImageViewerSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { ReactComponent as ArrowRightIcon } from "assets/icons/slider_arrow_right_2.svg";

const PropertyDetailsGallery = () => {
  const { propertyDetails } = useProperties();
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    navigation: {
      nextEl: `.swiper-property-details-next`,
      prevEl: `.swiper-property-details-prev`,
    },
    onSlideChange: (swiper) => {
      setCurrentIndex(swiper.activeIndex);
    },
  };

  if (propertyDetails.pictures.length === 1) {
    return (
      <div className="h-[263px] sm:h-[320px] md:h-[475px] w-full pb-4 sm:p-6">
        <img
          className="w-full object-cover h-full sm:rounded-[12px]"
          src={propertyDetails.pictures[0]}
          alt="property"
          onError={(e) => (e.target.src = fallbackImage)}
        />
      </div>
    );
  }

  return (
    <div className="h-[263px] sm:h-[320px] md:h-[475px] w-full pb-4 sm:p-6 flex items-start gap-3">
      {/* Main Image - First Picture */}
      <div className="w-full relative sm:w-1/2 md:w-[60%] flex-1 h-full">
        <img
          className="w-full object-cover h-full rounded-tl-[12px] rounded-bl-[12px] hidden sm:block"
          src={propertyDetails.pictures[0]}
          alt="property"
          onError={(e) => (e.target.src = fallbackImage)}
        />
        <Swiper className="sm:!hidden h-[247px] w-full" {...settings}>
          {propertyDetails?.pictures?.length > 0 &&
            propertyDetails.pictures.map((image, ind) => (
              <SwiperSlide key={ind}>
                <img
                  className="w-full object-cover h-full"
                  src={image}
                  alt="property"
                  onError={(e) => (e.target.src = fallbackImage)}
                />
              </SwiperSlide>
            ))}
        </Swiper>
        {/* Custom Navigation Arrows */}
        <div
          className={`swiper-property-details-next inline-flex sm:hidden absolute right-[17px] top-1/2 z-[1] -translate-y-1/2 cursor-pointer w-9 h-9 rounded-[46px] swiper-arrow-bg items-center justify-center`}
        >
          <ArrowRightIcon fill="white" width={16} height={16} />
        </div>
        <div
          className={`swiper-property-details-prev inline-flex sm:hidden absolute left-[17px] top-1/2 z-[1] -translate-y-1/2 cursor-pointer rotate-180 w-9 h-9 rounded-[46px] swiper-arrow-bg items-center justify-center`}
        >
          <ArrowRightIcon fill="white" width={16} height={16} />
        </div>
        <div
          onClick={() => setIsImageViewerOpen(true)}
          className="absolute sm:hidden bottom-4 right-4 h-[24px] rounded-[32px] py-1 px-3 bg-[#0A0A14] bg-opacity-70 cursor-pointer flex items-center z-[1]"
        >
          <p className="text-[12px] font-medium text-white line-clamp-1">
            {currentIndex + 1} out of {propertyDetails.pictures.length}
          </p>
        </div>
      </div>

      {/* Side Gallery */}
      <div className="hidden sm:inline-grid grid-cols-2 grid-rows-2 items-center gap-3 w-1/2 md:w-[40%] h-full">
        {propertyDetails.pictures.slice(1, 4).map((image, index) => (
          <img
            key={index}
            className={`w-full object-cover h-full ${
              index === 1 ? "sm:rounded-tr-[12px]" : ""
            }`}
            src={image}
            alt="property"
            onError={(e) => (e.target.src = fallbackImage)}
          />
        ))}
        {/* Last Image with Overlay */}
        {propertyDetails.pictures.length > 4 && (
          <div className="relative h-full">
            <img
              className="w-full object-cover h-full sm:rounded-br-[12px]"
              src={propertyDetails.pictures[4]} // 5th image
              alt="property"
              onError={(e) => (e.target.src = fallbackImage)}
            />
            <div
              onClick={() => setIsImageViewerOpen(true)}
              className="absolute bottom-[22.5px] right-[18px] h-[28px] rounded-[32px] py-1 px-3 bg-[#0A0A14] bg-opacity-70 cursor-pointer flex items-center space-x-2"
            >
              <ImageGalleryIcon />
              <p className="text-[12px] font-medium text-white line-clamp-1">
                Scopri {propertyDetails.pictures.length - 4}+ Foto
              </p>
            </div>
          </div>
        )}
      </div>
      {isImageViewerOpen && (
        <CardImageViewerSlider
          setIsImageViewerOpen={setIsImageViewerOpen}
          pictures={propertyDetails?.pictures}
        />
      )}
    </div>
  );
};

export default PropertyDetailsGallery;
